// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"456":"18c01b2b","751":"7470810f","765":"bf98c027","836":"95669b54"}[chunkId] + ".chunk.js";
};